<template>
  <div class="tuolele-main-box payment-setting">
    <div class="font-size24 color-black">托乐乐app-支付渠道使用设置</div>
    <el-row type="flex" justify="space-between">
      <div class="flex-wrap payment-type">
        <img src="../../assets/img/payment-icon1.png" class>
        <div class="payment-name">
          <b class="color-black zfb">支付宝支付</b>
          <p class="font-size12">请确保支付宝配置成功，支付渠道才能开启</p>
        </div>
        <!-- <el-button type="primary" @click="alipaySetting">支付宝配置</el-button> -->
      </div>
      <div style="padding-top:15px">
        <el-switch
          v-model="switchFlag.PAYMENT_MODE_ALIPAY"
          active-color="#4c84ff"
          inactive-color="#ccc"
          @change="changeSwitch('PAYMENT_MODE_ALIPAY')"
        />
      </div>
    </el-row>
    <el-row type="flex" justify="space-between">
      <div class="flex-wrap payment-type">
        <img src="../../assets/img/payment-icon5.png" class>
        <div class="payment-name">
          <b class="color-black">微信支付</b>
        </div>
      </div>
      <div style="padding-top:15px">
        <el-switch
          v-model="switchFlag.PAYMENT_MODE_WX"
          active-color="#4c84ff"
          @change="changeSwitch('PAYMENT_MODE_WX')"
        />
      </div>
    </el-row>
    <el-row type="flex" justify="space-between">
      <div class="flex-wrap payment-type">
        <img src="../../assets/img/payment-icon2.png" class>
        <div class="payment-name">
          <b class="color-black">POS支付</b>
        </div>
      </div>
      <div style="padding-top:15px">
        <el-switch
          v-model="switchFlag.PAYMENT_MODE_POS"
          active-color="#4c84ff"
          @change="changeSwitch('PAYMENT_MODE_POS')"
        />
      </div>
    </el-row>
    <el-row type="flex" justify="space-between">
      <div class="flex-wrap payment-type">
        <img src="../../assets/img/payment-icon3.png" class>
        <div class="payment-name">
          <b class="color-black">直接转账</b>
        </div>
      </div>
      <div style="padding-top:15px">
        <el-switch
          v-model="switchFlag.PAYMENT_MODE_TURN"
          active-color="#4c84ff"
          @change="changeSwitch('PAYMENT_MODE_TURN')"
        />
      </div>
    </el-row>
    <el-row type="flex" justify="space-between">
      <div class="flex-wrap payment-type">
        <img src="../../assets/img/payment-icon4.png" class>
        <div class="payment-name">
          <b class="color-black">现金支付</b>
        </div>
      </div>
      <div style="padding-top:15px">
        <el-switch
          v-model="switchFlag.PAYMENT_MODE_CASH"
          active-color="#4c84ff"
          @change="changeSwitch('PAYMENT_MODE_CASH')"
        />
      </div>
    </el-row>
    
  </div>
</template>
<script>
export default {
  name: 'PaymentSetting',
  components: {},
  data() {
    return {
      switchFlag: {
        PAYMENT_MODE_ALIPAY: false,
        PAYMENT_MODE_POS: false,
        PAYMENT_MODE_TURN: false,
        PAYMENT_MODE_CASH: false
      }
    }
  },
  mounted() {
    this.getVasList()
  },
  methods: {
    getVasList() {
      this.$http.getVasList().then(res => {
        this.switchFlag = res.data.company_switch
        for (const key in this.switchFlag) {
          this.switchFlag[key] = this.switchFlag[key] == 1
        }
      })
    },
    alipaySetting() {
      this.$router.push({ path: 'paymentAlipay' })
    },
    changeSwitch(key) {
      const value = this.switchFlag[key] ? '1' : '0'
      this.$http.setVasSubmit({ key: key, value: value }).then(res => {
        console.log(res)
        this.getVasList()
      })
    }
  }
}
</script>
<style lang="scss">
.payment-setting {
  .el-row {
    padding: 30px;
    margin-top: 30px;
    background-color: #fafafa;
    border-radius: 6px;
  }
  .payment-type {
    img {
      width: 60px;
      height: 60px;
      margin-right: 30px;
    }
    .payment-name {
      b {
        display: block;
        margin-top: 20px;
      }
      b.zfb {
        margin: 8px 0;
      }
    }
    .el-button--primary {
      width: 100px !important;
      height: 40px !important;
      padding: 0 !important;
      margin: 8px 0 0 40px;
    }
  }
}
</style>
